import { c as t } from "../../../../index.esm-BeDSGXP5.js";
import { css as e } from "styled-components";
const a = {
  base: ({ theme: l }) => /* @__PURE__ */ e([
    "",
    " ",
    ""
  ], l.resets.space, t({
    fontWeight: "regular",
    color: l.componentColors.text.default
  })),
  paragraph: () => /* @__PURE__ */ e([
    "",
    ""
  ], t({
    paddingBottom: "xs"
  })),
  xSmall: () => /* @__PURE__ */ e([
    "",
    ""
  ], t({
    fontSize: [
      "textXsmallMobile",
      null,
      "textXsmallDesktop"
    ],
    lineHeight: [
      "textXsmallMobile",
      null,
      "textXsmallDesktop"
    ]
  })),
  small: () => /* @__PURE__ */ e([
    "",
    ""
  ], t({
    fontSize: [
      "textSmallMobile",
      null,
      "textSmallDesktop"
    ],
    lineHeight: [
      "textSmallMobile",
      null,
      "textSmallDesktop"
    ]
  })),
  medium: () => /* @__PURE__ */ e([
    "",
    ""
  ], t({
    fontSize: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    lineHeight: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ]
  })),
  large: () => /* @__PURE__ */ e([
    "",
    ""
  ], t({
    fontSize: [
      "textLargeMobile",
      null,
      "textLargeDesktop"
    ],
    lineHeight: [
      "textLargeMobile",
      null,
      "textLargeDesktop"
    ]
  })),
  dark: ({ theme: l }) => /* @__PURE__ */ e([
    "",
    ""
  ], t({
    color: l.componentColors.text.dark
  })),
  light: ({ theme: l }) => /* @__PURE__ */ e([
    "",
    ""
  ], t({
    color: l.componentColors.text.light
  }))
};
export {
  a as default
};
